import { SimpleGrid } from '@chakra-ui/react'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'

import { getGrass } from 'services/grass/action'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'
import Card from 'components/Card'
import { transformHttpToHttps } from 'utils'

const getSplittedName = (value: any) => {
  const [name] = value.toLowerCase().split('GRAMA ')
  return name
}


const Dicas: NextPage<any> = ({ data }) => {
  const router = useRouter()  
  
  return (
    <Layout
      category="Gramas"
      title="Tipos de gramas para comprar"
      description="Selecione o tipo de grama que está procurando, saiba mais sobre cada variedade, faça a melhor escolha de acordo com sua necessidade e estamos a disposição..."
      keywords='gramas, tipos de grama, qual melhor tipo de grama, grama para jardim, grama para beira de piscina, grama para talude, grama para sombra, grama para campo de futebol, grama para chácara'
      categorySize="1.6rem"
    >
      <section>
        <Container>
          <SimpleGrid columns={[1, 1, 2, null, 3]} spacing={15}>
            {data?.map((item: any) => (
              <Card
                key={`grass-${item.id}`}
                image={transformHttpToHttps(item.x_featured_media_original)}
                title={getSplittedName(item.title.rendered)}
                description={`${item.excerpt.rendered} ...`}
                onPress={() => router.push(item.slug)}
                metaImgTitle={item?.acf?.title_img_othergrass}
                metaImgAlt={item?.acf?.alt_img_othergrass}
                metaTitle={item?.acf?.title_text_othergrass}
              />
            ))}
          </SimpleGrid>
        </Container>
      </section>
    </Layout>
  )
}

export async function getStaticProps() {
  const data = await getGrass()

  return {
    props: {
      data
    },
    revalidate: 10,
  }
}

export default Dicas
